import axios, { AxiosRequestConfig } from 'axios';
import Toast from './Toast';

/**
 * Uploads the file data to storage. https://learn.microsoft.com/en-us/rest/api/storageservices/put-blob?tabs=azure-ad
 * @param blobData - The file data to be uploaded (as Uint8Array).
 * @param url - The storage URL.
 */
export const AzureStorage = async (
    blobData: Uint8Array,
    url: string,
    callback: (progress: number) => void,
    status: (ev: any) => void
): Promise<void> => {
    const config: AxiosRequestConfig = {
        onUploadProgress: (progressEvent) => {
            const progress: number = Math.round(
                (progressEvent.loaded / progressEvent.total) * 100
            );
            callback(progress);
        },
        headers: {
            'x-ms-blob-type': 'BlockBlob',
            'x-ms-date': new Date().toUTCString(),
            'x-ms-version': '2015-02-21',
            'Content-Type': 'application/octet-stream',
            'x-ms-meta-m1': 'v1',
            'x-ms-meta-m2': 'v2',
            'Content-Length': blobData.length,
        },
    };

    try {
        await axios
            .put(url, blobData, config)
            .then((res) => {
                console.log('File uploaded successfully!', res.statusText);
                status(res.statusText);
            })
            .catch((e) => {
                throw e;
            });
    } catch (error: any) {
        // const axiosError: AxiosError = error;
        if (error && error.response && error.response.data) {
            console.log('error message', error);
            Toast.showErrorMessage(error.response.data.msg);
        }
        callback(-1);
        throw error;
    }
};
